import { render, staticRenderFns } from "./ManagementBalanceCreationDialog.vue?vue&type=template&id=781ff57e"
import script from "./ManagementBalanceCreationDialog.vue?vue&type=script&lang=js"
export * from "./ManagementBalanceCreationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports